module.exports = __webpack_public_path__ + "static/media/background-9.e63e0626.jpg";